export default function Footer() {
  return (
    <div className="footer container">
      <div className="footer-section">
        <p className="title">platepalcom</p>
        <p>FoodiesHub is a place where you can please your soul and tummy with delicious food recepies of all cuisine. And our service is absolutely free.</p>
        <p>&copy; 2021 | All Rights Reserved</p>
      </div>
      <div className="footer-section">
        <p className="title">Contact Us</p>
        <p>platepal@gmail.com</p>
        <p>+91 1234567890</p>
        <p>2382 street NYC</p>
      </div>
      <div className="footer-section">
        <p className="title">Social</p>
        <p>Facebook</p>
        <p>Twitter</p>
        <p>Instagram</p>
      </div>
    </div>
  )
}
